export enum SortOptions {
	RELEVANCE = 1,
	TITLE_ASC = 3,
	TITLE_DESC = 13,
	DATE_ASC = 2,
	DATE_DESC = 6,
	FAVOURITED_ASC = 16,
	FAVOURITED_DESC = 17,
}
